import { groupedElemCount } from '@root/node_modules/pristinejs/src/utils';
import Pristine from '@root/node_modules/pristinejs/dist/pristine';

Pristine.addValidator('required-unless', function(value, field, fieldValue) {
  let $input = document.querySelector('[name="'+field+'"]');
  const input_type = $input.type;

  if(['radio', 'checkbox'].indexOf($input.type) !== -1) {
    $input = document.querySelector('[name="'+field+'"]:checked');
  }

  if(
    ($input && $input.value !== fieldValue)
    || (!$input && input_type === 'checkbox')
  ) {
    return (['radio', 'checkbox'].indexOf(this.type) !== -1)
      ? groupedElemCount(this)
      : value !== undefined && value !== '';
  }

  return true;
}, "This field is required", 99, false);

Pristine.addValidator('required-if', function(value, field, fieldValue) {
  let $input = document.querySelector('[name="'+field+'"]');

  if(['radio', 'checkbox'].indexOf($input.type) !== -1) {
    $input = document.querySelector('[name="'+field+'"]:checked');
  }

  if($input && $input.value === fieldValue) {
    // same as required check
    return (['radio', 'checkbox'].indexOf(this.type) !== -1) ? groupedElemCount(this) : value !== undefined && value !== '';
  }

  return true;
}, "This field is required", 99, false);

export default Pristine;
